import React from 'react';
import ReactDOM from 'react-dom';
import {MultiLanguageField} from './components';

const $ = window.$;

// render multi-language input fields
function renderMultiLanguageInputFields(containerElements) {
  let browserLang = 'zht';
  if ($('#browser-lang').length) {
    browserLang = $('#browser-lang').text();
  }
  if (!['zht', 'en'].includes(browserLang)) {
    browserLang = 'zht';
  }

  containerElements.each(function() {
    const fieldContainer = $(this);
    const fieldName = fieldContainer.attr('field-name');
    const fieldType = fieldContainer.attr('field-type');
    const defaultLanguage = fieldContainer.attr('default-language');
    const supportLanguages = fieldContainer.attr('support-languages-str').split(',');
    const oldValuesElement = $(this).siblings('.multi-language-field-old-values');
    const oldValues = (oldValuesElement.length) ? JSON.parse(oldValuesElement.text()) : null;
    const fieldLabel = fieldContainer.attr('field-label');
    const fieldRequired = (fieldContainer.attr('field-required')) ? fieldContainer.attr('field-required') === 'true' : false;
    const otherFieldProps = (fieldContainer.attr('other-field-props')) ? JSON.parse(fieldContainer.attr('other-field-props')) : {};

    ReactDOM.render(
      <MultiLanguageField
        fieldName={fieldName}
        fieldType={fieldType}
        defaultLanguage={defaultLanguage}
        supportLanguages={supportLanguages}
        oldValues={oldValues}
        fieldLabel={fieldLabel}
        fieldRequired={fieldRequired}
        otherFieldProps={otherFieldProps}
        browserLang={browserLang} />,
      this
    );
  });
}

window.renderMultiLanguageInputFields = renderMultiLanguageInputFields;

$(function() {
  renderMultiLanguageInputFields($('.multi-language-field-container:not(.multi-language-field-not-init)'));
});
